import { useState, useEffect, useMemo } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import FilterBar from "../components/FilterBar";
import VehicleGrid from "../components/VehicleGrid";
import Footer from "../components/Footer";
import { vehicles as allVehicles } from "../data/vehicles";

const AanbodPage = () => {
  const [search, setSearch] = useState("");
  const [brand, setBrand] = useState("Alle merken");
  const [maxPrice, setMaxPrice] = useState("any");
  const [sort, setSort] = useState("newest");
  const [loading, setLoading] = useState(false);

  // Briefly toggle loading state when filters change for a premium feel
  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 350);
    return () => clearTimeout(t);
  }, [search, brand, maxPrice, sort]);

  const filtered = useMemo(() => {
    let list = [...allVehicles];
    if (search.trim()) {
      const q = search.trim().toLowerCase();
      list = list.filter(
        (v) =>
          v.brand.toLowerCase().includes(q) ||
          v.model.toLowerCase().includes(q) ||
          v.title.toLowerCase().includes(q),
      );
    }
    if (brand && brand !== "Alle merken") {
      list = list.filter((v) => v.brand === brand);
    }
    if (maxPrice && maxPrice !== "any") {
      const max = parseInt(maxPrice, 10);
      list = list.filter((v) => v.price <= max);
    }
    switch (sort) {
      case "price_desc":
        list.sort((a, b) => b.price - a.price);
        break;
      case "price_asc":
        list.sort((a, b) => a.price - b.price);
        break;
      case "az":
        list.sort((a, b) => a.title.localeCompare(b.title));
        break;
      case "za":
        list.sort((a, b) => b.title.localeCompare(a.title));
        break;
      case "newest":
      default:
        list.sort((a, b) => b.year_iso.localeCompare(a.year_iso));
    }
    return list;
  }, [search, brand, maxPrice, sort]);

  const onReset = () => {
    setSearch("");
    setBrand("Alle merken");
    setMaxPrice("any");
    setSort("newest");
  };

  return (
    <div data-testid="aanbod-page" className="min-h-screen bg-ink-950">
      <Header />
      <main>
        <Hero />
        <FilterBar
          search={search}
          setSearch={setSearch}
          brand={brand}
          setBrand={setBrand}
          maxPrice={maxPrice}
          setMaxPrice={setMaxPrice}
          sort={sort}
          setSort={setSort}
          resultCount={filtered.length}
          totalCount={allVehicles.length}
          onReset={onReset}
        />

        <section
          data-testid="aanbod-grid-section"
          className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-12 py-14 md:py-20"
        >
          <VehicleGrid vehicles={filtered} loading={loading} />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AanbodPage;
